import { formatDate } from "library/utils";
import { HardshipState, PersonalDetailsState } from "./types";

export const getIsShortForm = ({ prescreening }: HardshipState) =>
  prescreening?.onHardshipInLast24Months === "false" &&
  (prescreening?.durationOfHardship === "hardship_arrangement_3_months" ||
    prescreening?.durationOfHardship === "hardship_arrangement_6_months");

export const getNumberOfSteps = (state: HardshipState) =>
  getIsShortForm(state) ? "3" : "6";

export const getBirthdate = (personalDetails?: PersonalDetailsState) =>
  formatDate(
    `${personalDetails?.applicantDetails.dateOfBirth.year}-${personalDetails?.applicantDetails.dateOfBirth.month}-${personalDetails?.applicantDetails.dateOfBirth.day}`,
  );

export const getAuthorisedPersonDetails = (
  personalDetails?: PersonalDetailsState,
) => ({
  ...personalDetails?.authorisedPersonDetails,
});

export const getApplicantDetails = (
  personalDetails?: PersonalDetailsState,
) => ({
  ...personalDetails?.applicantDetails,
});

export const hasPersonalLoan = (state: HardshipState) =>
  Boolean(
    state.yourAccounts?.accounts.some(
      ({ accountType }) => accountType === "personal-loan",
    ),
  );
